import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Store} from '@ngrx/store';

import { AnamneseProcessStep } from '../anamnese.component';
import { PROFESSIONAL_PRODUCT_KEYS, ProductInfoForKey, ProductKey, QuestionnaireScopeLevel } from 'libs/product/src/lib/models';
import { BothJawsUpdatedAction, ClearAnamneseAction, ProductSelectedAction, QuestionaireAnswersUpdatedAction } from 'libs/anamnese/src/lib/store/anamnese.actions';
import { QuestionaireService } from 'libs/questionaire/src/lib/services/questionaire.service';
import { ACTION } from 'libs/tm-common/src/lib/constants/subcomponent.actions';
import { AppState } from 'libs/tm-common/src/lib/store/reducers/reducers';

enum TreatmentSelectionSubstate {
	PRODUCT_SELECTION = 0,
	OPTIONS = 1,
	QUESTIONNAIRE = 2
}

@Component({
	selector: 'tm2-anamnese-treatment',
	templateUrl: './anamnese-treatment.component.html',
	styleUrls: ['./anamnese-treatment.component.scss']
})
export class AnamneseTreatmentComponent implements OnInit, OnChanges {

	@Input() anamnese;
	@Input() patient;
	@Input() isUserProfessionalCertified: boolean;
	@Input() isUserOrcadentCertified: boolean;
	@Input() isUserFunctionalSplintCertified: boolean;
	@Input() previousStep: AnamneseProcessStep;
	@Input() isProfessionalSubsequentOrder: boolean = false;

	@Output() next = new EventEmitter<any>();

	TreatmentSelectionSubstate = TreatmentSelectionSubstate;
	currentSubState: TreatmentSelectionSubstate = TreatmentSelectionSubstate.PRODUCT_SELECTION;

	// questionaire level
	questionnaireScopeLevel:QuestionnaireScopeLevel;
	isOrcadentProduct: boolean = false;
	isProfessionalProduct: boolean = false;

	ProductKey = ProductKey;

	constructor(private store: Store<AppState>,
				private questionaireService: QuestionaireService,
	) {

	}
	ngOnChanges(changes: SimpleChanges): void {
		if(changes['anamnese']){
			this.isOrcadentProduct = this.anamnese?.product?.key === ProductKey.ORCADENT_SCHIENE_ASSESSMENT;
			this.isProfessionalProduct = PROFESSIONAL_PRODUCT_KEYS.includes(this.anamnese?.product?.key);
		}
	}

	ngOnInit() {
		this.questionnaireScopeLevel = ProductInfoForKey[this.anamnese?.product?.key]?.questionnaireScopeLevel;
		if(this.previousStep === AnamneseProcessStep.SETUP_CHECKOUT){
			this.currentSubState = this.isProfessionalProduct
				|| this.isOrcadentProduct
				|| this.anamnese?.product?.key === ProductKey.MICHIGAN_SPLINT
				? TreatmentSelectionSubstate.QUESTIONNAIRE
				: TreatmentSelectionSubstate.OPTIONS;
		}else{
			this.currentSubState = TreatmentSelectionSubstate.PRODUCT_SELECTION;
		}
		if(this.isProfessionalSubsequentOrder){
			this.currentSubState = TreatmentSelectionSubstate.OPTIONS;
		}
	}


	done() {
		this.next.emit({type: ACTION.NEXT});
	}

	onNext(action) {
		switch (action.type) {

			case ACTION.PRODUCT_SELECTED:
				// store product info in redux store
				this.store.dispatch(new ProductSelectedAction(action.payload));
				this.isOrcadentProduct = action.payload.key === ProductKey.ORCADENT_SCHIENE_ASSESSMENT;

				if(this.isOrcadentProduct)
				{
					//skip options (jaw selection) for orcadent products and set it directly via action
					this.store.dispatch(new BothJawsUpdatedAction());
					this.currentSubState = TreatmentSelectionSubstate.QUESTIONNAIRE;
				}
				else
				{
					this.currentSubState = TreatmentSelectionSubstate.OPTIONS;
				}
				break;

			case ACTION.OPTIONS:
				if ( this.isProfessionalProduct || this.anamnese.product.key === ProductKey.MICHIGAN_SPLINT ) {
					this.questionnaireScopeLevel = ProductInfoForKey[this.anamnese.product.key].questionnaireScopeLevel;
					this.currentSubState = TreatmentSelectionSubstate.QUESTIONNAIRE;
				} else {
					this.done();
				}
				break;

			case ACTION.QUESTIONAIRE:
				this.store.dispatch(new QuestionaireAnswersUpdatedAction(action.payload,  this.anamnese?.product?.key));
				if( this.isProfessionalProduct ){
					this.questionaireService.getQuestionaireData();
				}
				this.done();
				break;

			case ACTION.BACK:
				if (this.currentSubState === TreatmentSelectionSubstate.QUESTIONNAIRE) {
					this.currentSubState = this.isOrcadentProduct ?
					 TreatmentSelectionSubstate.PRODUCT_SELECTION :
					 TreatmentSelectionSubstate.OPTIONS;
				}else if ( this.currentSubState === TreatmentSelectionSubstate.OPTIONS ) {
					this.currentSubState = TreatmentSelectionSubstate.PRODUCT_SELECTION
				} else {
					this.store.dispatch(new ClearAnamneseAction());
					this.next.emit({type: ACTION.BACK});
				}
		}


	}

}
